import { CEP_REGEX } from './constants';

export const NOT_NUMBERS = /\D+$/;

export const NUMBERS_AND_LETTERS = /[^A-Za-z0-9]+/g;

export const ONLY_NUMBERS_REGEX = /[^\d]/gi;

export const ONLY_NUMBERS_AND_COMMA_REGEX = /[^\d,]+/g;

export const THOUSAND_REGEX = /\B(?=(\d{3})+(?!\d))/g;

export type UNMASK_TYPES = 'ONLY_NUMBERS' | 'NUMBERS_AND_LETTERS';

export const formatCep = (cep?: string) => cep?.replace(CEP_REGEX, '$1-$2');

export const unmask = (value: string = '', unmaskType: UNMASK_TYPES = 'ONLY_NUMBERS') => {
	if (unmaskType === 'ONLY_NUMBERS') return value?.replace(ONLY_NUMBERS_REGEX, '');

	return value?.replace(NUMBERS_AND_LETTERS, '');
};
